// extracted by mini-css-extract-plugin
module.exports = {"containerClass":"LandingPage_containerClass__2ykHd","containerHeadingClass":"LandingPage_containerHeadingClass__3_PaZ"};